import { SCOUT_POINT_VALUES, SCOUT_DAILY_CAPS, SCOUT_LEVEL_THRESHOLDS, } from './scout-constants';
// ============================================
// ECONOMY CONFIGURATION
// ============================================
/** Default economy config values derived from scout-constants */
export const ECONOMY_CONFIG_DEFAULTS = {
    // Point values
    scanXp: SCOUT_POINT_VALUES.SCAN,
    feedbackXp: SCOUT_POINT_VALUES.FEEDBACK,
    issueReportXp: SCOUT_POINT_VALUES.ISSUE_REPORT,
    statusReportXp: SCOUT_POINT_VALUES.STATUS_REPORT,
    photoXp: SCOUT_POINT_VALUES.PHOTO,
    firstScanOfDayXp: SCOUT_POINT_VALUES.FIRST_SCAN_OF_DAY,
    streakBonusPerDay: SCOUT_POINT_VALUES.STREAK_BONUS_PER_DAY,
    streakBonusCap: SCOUT_POINT_VALUES.STREAK_BONUS_CAP,
    referralBonusXp: SCOUT_POINT_VALUES.REFERRAL_BONUS,
    companyReferralBonusXp: SCOUT_POINT_VALUES.COMPANY_REFERRAL_BONUS,
    // Daily caps
    scanDailyCap: SCOUT_DAILY_CAPS.SCAN,
    feedbackDailyCap: SCOUT_DAILY_CAPS.FEEDBACK,
    issueReportDailyCap: SCOUT_DAILY_CAPS.ISSUE_REPORT,
    statusReportDailyCap: SCOUT_DAILY_CAPS.STATUS_REPORT,
    photoDailyCap: SCOUT_DAILY_CAPS.PHOTO,
    // Trust thresholds
    trustHalveThreshold: 50,
    trustZeroThreshold: 20,
    // Level thresholds (mutable copy of the readonly constant)
    levelThresholds: SCOUT_LEVEL_THRESHOLDS.map((t) => ({ ...t })),
};
/**
 * Resolve an economy config by merging non-null overrides on top of defaults.
 * Pass null/undefined to get pure defaults.
 */
export function resolveEconomyConfig(override) {
    const defaults = ECONOMY_CONFIG_DEFAULTS;
    if (!override) {
        return {
            scanXp: defaults.scanXp,
            feedbackXp: defaults.feedbackXp,
            issueReportXp: defaults.issueReportXp,
            statusReportXp: defaults.statusReportXp,
            photoXp: defaults.photoXp,
            firstScanOfDayXp: defaults.firstScanOfDayXp,
            streakBonusPerDay: defaults.streakBonusPerDay,
            streakBonusCap: defaults.streakBonusCap,
            referralBonusXp: defaults.referralBonusXp,
            companyReferralBonusXp: defaults.companyReferralBonusXp,
            scanDailyCap: defaults.scanDailyCap,
            feedbackDailyCap: defaults.feedbackDailyCap,
            issueReportDailyCap: defaults.issueReportDailyCap,
            statusReportDailyCap: defaults.statusReportDailyCap,
            photoDailyCap: defaults.photoDailyCap,
            trustHalveThreshold: defaults.trustHalveThreshold,
            trustZeroThreshold: defaults.trustZeroThreshold,
            levelThresholds: defaults.levelThresholds.map((t) => ({ ...t })),
        };
    }
    return {
        scanXp: override.scanXp ?? defaults.scanXp,
        feedbackXp: override.feedbackXp ?? defaults.feedbackXp,
        issueReportXp: override.issueReportXp ?? defaults.issueReportXp,
        statusReportXp: override.statusReportXp ?? defaults.statusReportXp,
        photoXp: override.photoXp ?? defaults.photoXp,
        firstScanOfDayXp: override.firstScanOfDayXp ?? defaults.firstScanOfDayXp,
        streakBonusPerDay: override.streakBonusPerDay ?? defaults.streakBonusPerDay,
        streakBonusCap: override.streakBonusCap ?? defaults.streakBonusCap,
        referralBonusXp: override.referralBonusXp ?? defaults.referralBonusXp,
        companyReferralBonusXp: override.companyReferralBonusXp ?? defaults.companyReferralBonusXp,
        scanDailyCap: override.scanDailyCap ?? defaults.scanDailyCap,
        feedbackDailyCap: override.feedbackDailyCap ?? defaults.feedbackDailyCap,
        issueReportDailyCap: override.issueReportDailyCap ?? defaults.issueReportDailyCap,
        statusReportDailyCap: override.statusReportDailyCap ?? defaults.statusReportDailyCap,
        photoDailyCap: override.photoDailyCap ?? defaults.photoDailyCap,
        trustHalveThreshold: override.trustHalveThreshold ?? defaults.trustHalveThreshold,
        trustZeroThreshold: override.trustZeroThreshold ?? defaults.trustZeroThreshold,
        levelThresholds: override.levelThresholds ??
            defaults.levelThresholds.map((t) => ({ ...t })),
    };
}
//# sourceMappingURL=economy-config.js.map